var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-container',{attrs:{"title":_vm.$t('使用手册'),"cover":""}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }